import { actions } from "./actions";
import { initialState } from "./constants";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_DATA_REQUEST:
      return {
        ...state,
        getData: {
          loading: true,
          success: false,
          error: false,
        },
      };
    case actions.GET_DATA_SUCCESS:
      return {
        ...state,
        getData: {
          loading: false,
          success: true,
          error: false,
          data: action.payload,
        },
      };
    case actions.GET_DATA_FAILURE:
      return {
        ...state,
        getData: {
          loading: false,
          success: false,
          error: true,
        },
      };
    default:
      return state;
  }
};
export { reducer, actions, initialState };
